/// <amd-module name="TFS/Views/ProjectOverviewPage/Components/InviteUsersContext" />
import * as React from "react";
import { EntryPointModuleType, IInviteUserContext, IInviteUserContextProviderProps, WrappedComponentType } from "TFS/Views/ProjectOverviewPage/Components/InviteUser.Props";
import { IVssFeatureService } from "VSS/Platform/Feature";
import { useComponentContext } from "VSS/Platform/Layout";
import { WrappedComponentContextProvider } from "./WrappedComponentContextProvider";

export interface IInviteUsersInternalContext extends IInviteUserContext {
    useLegacyComponent?: boolean;
}

export const InviteUsersContext = React.createContext<IInviteUsersInternalContext | undefined>(undefined);

export interface IInviteUserContextInternalProviderProps extends Omit<IInviteUserContextProviderProps, "context"> {
}

export function InviteUsersContextProvider(props: IInviteUserContextInternalProviderProps & { children?: React.ReactNode; }): JSX.Element {
    const componentContext = useComponentContext();

    const wrappedType: WrappedComponentType = "inviteUserContextProvider";
    const entryPointModules: [EntryPointModuleType] = ["Aex/UserManagement/UserHub/EntryPoints/InviteUserContextProvider"];
    if (props.isOnPrem) {
        return (
            <InviteUsersContext.Provider
                value={{
                    useLegacyComponent: true,
                    onFlowStart: () => undefined,
                }}>
                {props.children}
            </InviteUsersContext.Provider>
        );
    }

    // use remote context provider
    return (
    <WrappedComponentContextProvider<IInviteUserContext | undefined, IInviteUserContextProviderProps>
        context={InviteUsersContext}
        modules={entryPointModules}
        wrappedType={wrappedType}
        dependencies={[
            "ms.vss-aex-user-management.aex-user-management-service-context",
            "ms.vss-aex-user-management.aex-user-hub-data-provider",
            "ms.vss-aex-user-management.collection-user-management-shared-data",
            "ms.vss-aex-user-management.user-hub-content",
        ]}
        {...props}
    />
    );
}
